module.exports = __webpack_public_path__ + "static/img/xiamiMusic.e8a5c18f.png";